import classNames from "classnames/bind";
import UIIcon from "common/blocks/UIIcon";
import type { BACKGROUNDABLE_ICONS, NON_BACKGROUNDABLE_ICONS } from "common/blocks/UIIcon";

import styles from "./CollectionTransferDeliveryWidget.module.scss";

const cx = classNames.bind(styles);

type TransferDeliveryRowProps = {
    icon: keyof typeof NON_BACKGROUNDABLE_ICONS | keyof typeof BACKGROUNDABLE_ICONS;
    children: React.ReactNode;
    className?: string;
    price?: string | number;
};

const TransferDeliveryRow = ({ icon, price, className, children }: TransferDeliveryRowProps) => (
    <div className={cx("row", className)}>
        <UIIcon className={cx("icon")} icon={icon} />
        <div className={cx("content")}>{children}</div>
        {price && (
            <div className={cx("price")}>
                <strong>{price}</strong>
            </div>
        )}
    </div>
);

export default TransferDeliveryRow;
